var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Clear';
import { Box, Button, Checkbox, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, MenuItem, Typography, } from '@mui/material';
import { EmailOnlyField, Password, RoleSelector, SEVERITY, ToastDispatchContext, VerificationMethodSelector, YearMonthDay, } from 'ui-lib';
import { Field, Formik } from 'formik';
import { Select, TextField } from 'formik-mui';
import { Util } from 'verid-shared-lib';
import { useOrgService } from 'ui-lib';
import { Role, VerificationMethodType } from 'lib/api/api-types';
import { usePersonOrgService } from 'ui-lib';
import { ClientLogger } from 'lib/client-logger';
import { useErrorHandler } from 'lib/use-error-handler';
import { dialogClasses } from 'style/sharedCssClasses';
import { PersonOrgSearch } from './PersonOrgSearch';
import { theme } from 'style/theme';
import { EnumGenderTypes } from '../../lib/enums';
import { useVeridApi } from 'ui-lib';
var DEBUG = false;
export function AddPersonOrg(props) {
    var personOrgService = usePersonOrgService();
    var errorHandler = useErrorHandler('EditOrg');
    var orgService = useOrgService();
    var _a = useState(undefined), org = _a[0], setOrg = _a[1];
    var formRef = useRef(null);
    var _b = useState(false), adding = _b[0], setAdding = _b[1];
    var toastDispatch = useContext(ToastDispatchContext);
    var veridApolloClient = useVeridApi().clientWithAuth;
    useEffect(function () {
        if (props.orgId) {
            orgService
                .org(props.orgId)
                .then(function (resp) {
                var data = resp.data;
                var respOrg = data && data.org;
                DEBUG && ClientLogger.debug('EditOrg', 'load org', { resp: resp, respOrg: respOrg, org: org });
                if (respOrg) {
                    setOrg(__assign({}, respOrg)); // copy to avoid mutating the original and causing an apollo error
                }
                else {
                    errorHandler.handleErrors({ graphQLErrors: resp.errors });
                }
            })
                .catch(function (err) {
                errorHandler.handleErrors({ error: err });
            });
        }
    }, [props.orgId]);
    function save(values) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var role, resp, id, verif, selectedIdTypes, respCreate;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        DEBUG && ClientLogger.debug('AddPersonOrg', 'save', { values: values });
                        role = values.role;
                        if (!role) {
                            errorHandler.handleErrors({ error: 'Role is required' });
                            return [2 /*return*/];
                        }
                        if (org && !Util.checkValidEmailDomain(org.emailDomain, role, values.email)) {
                            errorHandler.handleErrors({ error: "Email domain must end with ".concat(org.emailDomain[role]) });
                            return [2 /*return*/];
                        }
                        verif = values.verification;
                        if (!(!verif || !verif.passed)) return [3 /*break*/, 1];
                        errorHandler.handleErrors({ error: 'Successful verification is required' });
                        return [2 /*return*/];
                    case 1:
                        if (!!((_a = values.verification) === null || _a === void 0 ? void 0 : _a.passed)) return [3 /*break*/, 2];
                        errorHandler.handleErrors({ error: 'Successful verification is required' });
                        return [2 /*return*/];
                    case 2:
                        selectedIdTypes = (_b = values.idTypes) === null || _b === void 0 ? void 0 : _b.filter(function (idType) { return idType.id !== undefined; });
                        return [4 /*yield*/, personOrgService.personOrgCreateNewPerson({
                                orgId: props.orgId,
                                role: role,
                                email: values.email,
                                password: values.temporaryPassword,
                                verification: {
                                    title: values.title,
                                    firstName: values.firstName,
                                    middleName: values.middleName,
                                    lastName: values.lastName,
                                    methodId: values === null || values === void 0 ? void 0 : values.verification.id,
                                    dateOfBirth: values.dateOfBirth,
                                    gender: values.gender,
                                    idTypes: selectedIdTypes && selectedIdTypes.length > 0
                                        ? selectedIdTypes.map(function (idType) { return ({
                                            id: idType.id,
                                            idNumber: idType.idNumber,
                                            idExpiry: idType.idExpiry,
                                        }); })
                                        : undefined,
                                    passed: values === null || values === void 0 ? void 0 : values.verification.passed,
                                },
                                systemAccount: values.systemAccount,
                            })];
                    case 3:
                        respCreate = _e.sent();
                        id = (_d = (_c = respCreate.data) === null || _c === void 0 ? void 0 : _c.personOrgCreateNewPerson) === null || _d === void 0 ? void 0 : _d.id;
                        resp = respCreate;
                        DEBUG && ClientLogger.debug('AddPersonOrg', 'add resp', { resp: resp, id: id });
                        _e.label = 4;
                    case 4:
                        if (id) {
                            if (values.attachToPersonId) {
                                toastDispatch({
                                    severity: SEVERITY.SUCCESS,
                                    msg: "Existing person record for ".concat(values.firstName, " ").concat(values.lastName, " as added to this organization"),
                                    autoClose: true,
                                });
                            }
                            else {
                                toastDispatch({
                                    severity: SEVERITY.SUCCESS,
                                    msg: "New person record for ".concat(values.firstName, " ").concat(values.lastName, " as added to this organization"),
                                    autoClose: true,
                                });
                            }
                            DEBUG && ClientLogger.debug('AddPersonOrg', 'closing');
                            props.onClose();
                        }
                        else {
                            errorHandler.handleErrors({ graphQLErrors: resp.errors });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    DEBUG && ClientLogger.debug('AddPersonOrg', 'render', { props: props, formRef: JSON.stringify(formRef.current) });
    return (_jsx(_Fragment, { children: _jsx(Formik, __assign({ innerRef: formRef, initialValues: {
                title: '',
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: '',
                role: Role.USER,
                email: '',
                temporaryPassword: '',
                attachToPersonId: '',
                verification: {
                    // @ts-ignore TODO - upgrade: why?
                    id: '',
                    // @ts-ignore TODO - upgrade
                    idTypes: [],
                    // @ts-ignore TODO - upgrade
                    passed: false,
                    // @ts-ignore TODO - upgrade
                    verificationMethodType: VerificationMethodType.PERSONAL_KNOWLEDGE,
                },
                idTypes: [],
                systemAccount: false,
            }, validate: function (values) {
                var errors = {};
                return errors;
            }, onSubmit: function (values, actions) {
                DEBUG && ClientLogger.debug('CreatePatient', "onSubmit values", values);
                save(values);
            } }, { children: function (_a) {
                var _b, _c;
                var submitForm = _a.submitForm, isSubmitting = _a.isSubmitting, errors = _a.errors, values = _a.values, setFieldValue = _a.setFieldValue, touched = _a.touched, setFieldError = _a.setFieldError, setFieldTouched = _a.setFieldTouched, dirty = _a.dirty, handleChange = _a.handleChange;
                return (_jsxs(_Fragment, { children: [!adding && (_jsxs(_Fragment, { children: [_jsxs(DialogTitle, __assign({ sx: dialogClasses.dialogTitle }, { children: ["Search", _jsx(IconButton, __assign({ onClick: props.onClose, size: "large" }, { children: _jsx(CloseIcon, { sx: dialogClasses.closeIcon }) }))] })), _jsxs(DialogContent, { children: [_jsx(RoleSelector, { name: "role" }), _jsx(PersonOrgSearch, { org: org, role: values.role, onClose: function () { }, onSelect: function (person, id) {
                                                setFieldValue('attachToPersonId', person.id);
                                                DEBUG &&
                                                    ClientLogger.debug('AddPersonOrg', 'onSelect', {
                                                        person: person || 'undefined',
                                                        personId: person.id,
                                                        id: id,
                                                        role: values.role,
                                                    });
                                                save({
                                                    attachToPersonId: person.id,
                                                    role: values.role,
                                                });
                                            }, onSearch: function (searchCriteria) {
                                                setFieldValue('lastName', searchCriteria.lastName);
                                                setFieldValue('firstName', searchCriteria.firstName);
                                            } })] })] })), adding && (_jsxs(_Fragment, { children: [_jsxs(DialogTitle, __assign({ sx: dialogClasses.dialogTitle }, { children: ["Add a Person", _jsx(IconButton, __assign({ onClick: props.onClose, size: "large" }, { children: _jsx(CloseIcon, { sx: dialogClasses.closeIcon }) }))] })), _jsxs(DialogContent, { children: [_jsx(VerificationMethodSelector, { baseName: "verification", baseNameIdTypes: "idTypes", orgId: props.orgId, setFieldValue: setFieldValue, readFromVerid: true, style: {
                                                inputField: {
                                                    width: '100%',
                                                    marginTop: '12px',
                                                },
                                            } }), _jsx(Field, { component: TextField, name: "title", label: "Title", placeholder: "Enter the tite (Mr. Ms. etc)", type: "text", fullWidth: true, variant: "outlined", "data-test": "name-textfield", sx: dialogClasses.inputField }), _jsx(Field, { component: TextField, name: "firstName", label: "First Name", placeholder: "Enter the first name", type: "text", fullWidth: true, variant: "outlined", "data-test": "new-patient-middle-name-textfield", sx: dialogClasses.inputField }), _jsx(Field, { component: TextField, name: "middleName", label: "Middle Name", placeholder: "Enter the middle name", type: "text", fullWidth: true, variant: "outlined", "data-test": "name-textfield", sx: dialogClasses.inputField }), _jsx(Field, { component: TextField, name: "lastName", label: "Last Name", placeholder: "Enter the last name", type: "text", fullWidth: true, variant: "outlined", "data-test": "name-textfield", sx: dialogClasses.inputField }), _jsx(Grid, __assign({ sx: dialogClasses.caption }, { children: _jsx(Typography, __assign({ color: "textPrimary", align: "left", variant: "caption" }, { children: "Date of Birth" })) })), _jsxs(Grid, __assign({ container: true }, { children: [_jsx(Box, __assign({ mt: 1, sx: __assign({}, (((_b = errors.dateOfBirth) === null || _b === void 0 ? void 0 : _b.length) && dialogClasses.errorBlock)) }, { children: _jsx(YearMonthDay, { readonly: false, theme: theme, dateFieldName: "dateOfBirth", value: values.dateOfBirth || '', errors: errors, touched: touched, setFieldValue: setFieldValue }) })), ((_c = errors.dateOfBirth) === null || _c === void 0 ? void 0 : _c.length) && (_jsx(Grid, { children: _jsx(Typography, __assign({ align: "left", variant: "caption" }, { children: errors.dateOfBirth })) }))] })), _jsx(Grid, __assign({ container: true }, { children: _jsx(Grid, __assign({ size: "grow" }, { children: _jsx(Box, __assign({ mt: 1 }, { children: _jsx(FormControl, __assign({ sx: dialogClasses.fullWidthField, fullWidth: true }, { children: _jsxs(Field, __assign({ component: Select, name: "gender", inputProps: {
                                                                id: 'gender',
                                                            }, label: "Sex", variant: "outlined", disabled: false, "data-test": "new-patient-gender-textfield" }, { children: [_jsx(MenuItem, __assign({ value: EnumGenderTypes.M }, { children: "Male" })), _jsx(MenuItem, __assign({ value: EnumGenderTypes.F }, { children: "Female" })), _jsx(MenuItem, __assign({ value: EnumGenderTypes.U }, { children: "Other" }))] })) })) })) })) })), _jsx(RoleSelector, { name: "role" }), _jsx(EmailOnlyField, {}), _jsx(Password, { name: "temporaryPassword", fullWidth: true }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: values.systemAccount }), label: "System Account?", name: "systemAccount", onChange: handleChange })] })] })), _jsxs(DialogActions, { children: [!adding && (_jsx(Box, __assign({ mr: 1 }, { children: _jsx(Typography, __assign({ variant: "body1" }, { children: "If you can't find the person, Add Person" })) }))), _jsx(Button, __assign({ onClick: function () { return setAdding(!adding); }, variant: adding ? 'outlined' : 'contained', color: "primary" }, { children: adding ? 'Back to Search' : 'Add Person' })), adding && (_jsx(Button, __assign({ type: "submit", variant: "contained", color: "primary", onClick: function () { return save(values); } }, { children: "Add Person" })))] })] }));
            } })) }));
}
